<template>
  <b-overlay
      :show="processing"
      rounded="sm"
  >
    <template v-slot:overlay>
      <div
          v-if="processing"
          class="text-center p-4 bg-primary text-light rounded"
      >
        <b-icon
            icon="cloud-download"
            font-scale="4"
        />
        <div class="mb-3 mt-2">
          منتظر بمانید ...
        </div>
        <b-progress
            min="1"
            max="60"
            :value="counter"
            variant="success"
            height="3px"
            class="mx-n4 rounded-0"
        />
      </div>
    </template>
    <b-card
        :title="$t('foods.manageFoodList')"
    >
      <b-row>
        <b-col
            class="table-size"
        >
          <div class="custom-search">
            <b-row>
              <div class="filter-row">
                <b-button
                    class="mb-1 ml-1"
                    variant="primary"
                    :to="{ name: 'addfoodlist'}"
                    v-text="$t('common.new')"
                />
                <b-button
                    variant="gradient-secondary"
                    class="mb-1 mr-auto ml-1"
                    v-text="$t('common.export')"
                    @click="exportExcel"
                />

                <b-col md="2">
                  <b-form-group
                      :label="$t('common.title')"
                      label-for="Title"
                  >
                    <b-form-input
                        v-model="filterOptions.Title"
                        @keyup.enter="update(1)"
                    />
                  </b-form-group>
                </b-col>

                <b-col md="2">
                  <b-form-group
                      :label="$t('foods.meal')"
                      label-for="FoodMealId"
                  >
                    <z-food-meal
                        v-model="filterOptions.FoodMealId"
                        :multiple="false"
                        :clearable="true"
                    />
                  </b-form-group>
                </b-col>

                <b-col md="2">
                  <b-form-group
                      :label="$t('common.diet')"
                      label-for="DietId"
                  >
                    <z-diet
                        v-model="filterOptions.DietId"
                        :multiple="false"
                        :clearable="true"
                    />
                  </b-form-group>
                </b-col>

                <b-button
                    v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                    class="mb-1 mr-1"
                    variant="warning"
                    v-text="$t('common.filter')"
                    @click="update(1)"
                />
              </div>
            </b-row>
          </div>

          <b-table
              bordered
              hover
              striped
              :items="items"
              :fields="fields"
              class="mt-1 mb-2 position-relative"
              responsive
              :busy="loading"
              :no-local-sorting="true"
              :sort-by="filterOptions.SortBy"
              :sort-desc="filterOptions.IsDesc"
              @sort-changed="sortChange"
          >
            <template #cell(Id)="data">
              <b-link
                  :to="{ name: 'updatefoodlist', params: { id: data.value }}"
                  class="font-weight-bold"
              >
                #{{ data.value }}
              </b-link>
            </template>

            <template #cell(FoodMeal)="data">
            <span
                v-for="(item, index) in data.value"
                :key="index"
            >
              <b-badge
                  style="line-height: unset; margin: 2px;"
                  variant="info"
              >
                {{ item.Title }}
              </b-badge>
            </span>
            </template>

            <template #cell(Diet)="data">
            <span
                v-for="(item, index) in data.value"
                :key="index"
            >
              <b-badge
                  style="line-height: unset; margin: 2px;"
                  variant="success"
              >
                {{ item.Title }}
              </b-badge>
            </span>
            </template>

            <template #cell(FoodListDetails)="data">
            <span
                v-for="(item, index) in getCalorie(data.value)"
                :key="index"
            >
              <b-badge
                  style="line-height: unset; margin: 2px;"
                  variant="secondary"
              >
                {{ `${item.MinCalorie} تا ${item.MaxCalorie}` }}
              </b-badge>
            </span>
            </template>

            <template #cell(actions)="data">

              <div
                  class="text-nowrap"
              >
                <b-link
                    :to="{ name: 'duplicatefoodlist', params: { id: data.item.Id }}"
                >
                  <feather-icon
                      :id="`invoice-row-${data.item.Id}-copy-icon`"
                      icon="CopyIcon"
                      size="16"
                  />
                </b-link>

                <b-link
                    class="ml-1"
                    :to="{ name: 'updatefoodlist', params: { id: data.item.Id }}"
                >
                  <feather-icon
                      :id="`invoice-row-${data.item.Id}-send-icon`"
                      icon="EditIcon"
                      size="16"
                  />
                </b-link>

                <feather-icon

                    icon="TrashIcon"
                    size="16"
                    class="ml-1 cursor-pointer"
                    @click="remove(data.item.Id)"
                />

              </div>
            </template>

            <template #table-busy>
              <div
                  class="text-center my-2"
              >
                <b-spinner
                    variant="primary"
                    class="align-middle"
                />
                <strong class="ml-1" v-text="$t('common.loading')" />
              </div>
            </template>

          </b-table>

          <z-pagination
              :page="filterOptions.Page"
              :total-rows="totalRows"
              :loading="loading"
              @change="update"
          />

        </b-col>

      </b-row>
    </b-card>
  </b-overlay>
</template>

<script>

import ZFoodMeal from '@/tools/foodmeal.vue'
import ZDiet from '@/tools/diet.vue'

export default {
  name: 'FoodList',
  components: {
    ZFoodMeal,
    ZDiet,
  },
  data() {
    return {
      totalRows: 1000 * 1000,
      loading: true,
      filterOptions: {
        Title: null,
        FoodMealId: null,
        DietId: null,
        Page: 1,
        SortBy: 'Id',
        IsDesc: true,
      },
      fields: [
        {
          key: 'Id',
          label: '#',
          thClass: 'col-width-50',
          sortable: true,
        },
        {
          key: 'Title',
          label: this.$t('common.title'),
          sortable: true,
        },
        {
          key: 'FoodMeal',
          label: this.$t('foods.meal'),
        },
        {
          key: 'Diet',
          label: this.$t('common.diet'),
        },
        {
          key: 'FoodListDetails',
          label: this.$t('foods.rangeCalorie'),
        },
        {
          key: 'SelectedCount',
          label: this.$t('foods.UsableCount'),
          sortable: true,
        },
        {
          key: 'actions',
          label: '',
          thClass: 'col-width-50',
        },
      ],
      items: [],
      processing: false,
      counter: 1
    }
  },
  created() {
    if (this.$store.state.zirehState.listFilter[this.$options.name]) {
      this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
    }
    this.update()
  },
  methods: {
    sortChange(e) {
      if (e.sortBy) {
        this.filterOptions.SortBy = e.sortBy
        this.filterOptions.IsDesc = e.sortDesc
        this.update(1)
      }
    },
    update(pageNumber) {
      this.loading = true

      this.filterOptions.Page = pageNumber || this.filterOptions.Page

      this.$store.commit('zirehState/setListFilter', { key: this.$options.name, value: this.filterOptions })

      this.$http.post(
        this.$api.foodlist.getlist, this.filterOptions,
      )
        .then(res => {
          this.totalRows = res.totalRow
          this.items = res.data
        })
        .finally(() => {
          this.loading = false
        })
    },
    remove(id) {
      this.removeRow(this.$api.foodlist.remove, 'Id', id)
    },
    getCalorie(item) {
      const rangeCalorie = []
      item.forEach(x => {
        const range = { MinCalorie: x.MinCalorie, MaxCalorie: x.MaxCalorie }
        if (rangeCalorie.filter(a => a.MinCalorie === range.MinCalorie && x.MaxCalorie === range.MaxCalorie).length === 0) {
          rangeCalorie.push(range)
        }
      })
      return rangeCalorie
    },
    exportExcel(){

      var This = this

      This.counter = 1
      This.processing = true

      let interval = setInterval(() => {
        This.counter += 1
      }, 1000)

      let filename = 'food-list.xls'
      let xmlHttpRequest = new XMLHttpRequest()
      xmlHttpRequest.onreadystatechange = function() {
        if (xmlHttpRequest.readyState === 4 && xmlHttpRequest.status === 200) {

          let remaining = 60 - This.counter

          let interval2 = setInterval(() => {
            This.counter += 1
          }, 100)

          setTimeout(() => {

            let a = document.createElement('a')
            a.href = window.URL.createObjectURL(xmlHttpRequest.response)
            a.download = filename
            a.style.display = 'none'
            document.body.appendChild(a)
            a.click()
            a.remove()

            clearInterval(interval)
            clearInterval(interval2)
            This.processing = false

          },remaining * 100)
        }
      }
      let url = new URL(window.location.origin + '/api/foodlist/excel')
      Object.entries(this.filterOptions).forEach(([key, value]) => {
        if (value !== null) url.searchParams.set(key, value)
      })
      xmlHttpRequest.open("GET", url)
      xmlHttpRequest.setRequestHeader('Content-Type', 'application/json')
      xmlHttpRequest.setRequestHeader('Authorization', 'Bearer ' + localStorage.getItem('accessToken'))
      xmlHttpRequest.responseType = 'blob'
      xmlHttpRequest.send()
    },
  },
}
</script>
